import type { CallRecord } from '@/types';

export function recordMatchesExtension(record: CallRecord, extensionNumber: string) {
  const normalize = (value: string) => String(value || '').replace(/[^\d]/g, '');
  const target = normalize(extensionNumber);
  if (!target) return false;

  const values = [
    record.call_from,
    record.call_to,
    (record as any).call_from_number,
    (record as any).call_to_number,
    (record as any).call_from_name,
    (record as any).call_to_name,
  ];

  return values.some((value) => {
    const raw = String(value || '');
    const normalized = normalize(raw);
    return raw === extensionNumber || normalized === target;
  });
}

export function dispositionBucket(record: CallRecord) {
  const disposition = String(record.disposition || '').toLowerCase();
  if (
    disposition.includes('no answer') ||
    disposition.includes('noanswer') ||
    disposition.includes('missed')
  ) {
    return 'noAnswer';
  }
  if (disposition.includes('answer')) return 'answered';
  if (disposition.includes('busy')) return 'busy';
  if (disposition.includes('fail') || disposition.includes('cancel')) return 'failed';
  if (disposition.includes('voicemail')) return 'noAnswer';
  return 'noAnswer';
}

/** A call queue leg; Yeastar writes these as "Queue <name><number>". */
export function isQueueCall(record: CallRecord) {
  return /^Queue\s/i.test(String(record.call_to || ''));
}
